import { useEffect } from "react";
import { Card } from "semantic-ui-react";
import { useGetPermitRequestApprovalStatsMetric } from "../operations/queries/getPermitRequestApprovalStatsMetric";
import PermitRequestApprovalStats from "../components/PermitRequestApprovalStats";
import KpiTile from "../components/KpiTile";
import { useAppContext } from "../hooks/useAppContext";
import { PermitMetricScopeInput } from "../operations/queries/getPermitsCountByStatesMetric";

interface Props {
  scope?: PermitMetricScopeInput;
  /** When true, show KPI tiles (total/approved/rejected with deltas) above the gauge. */
  showKpiTiles?: boolean;
}

const PermitRequestApprovalStatsContainer = (props: Props) => {
  const { currentOrganization, currentPermitRegister } = useAppContext();

  const { getPermitRequestApprovalStatsMetric, data } = useGetPermitRequestApprovalStatsMetric();

  useEffect(() => {
    if (currentOrganization) {
      const activeScope: PermitMetricScopeInput = props.scope || {
        organizationId: currentOrganization.id,
        registerIds: currentPermitRegister?.id ? [currentPermitRegister.id] : null,
      };

      getPermitRequestApprovalStatsMetric({
        variables: { query: { scope: activeScope } },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization, currentPermitRegister, props.scope]);

  if (!data) return null;

  const stats = data.permitRequestApprovalStatsMetric;
  const hasDateRange = !!(props.scope?.dateFrom && props.scope?.dateTo);
  const comparisonHint = hasDateRange ? "vs previous period" : undefined;

  return (
    <>
      <PermitRequestApprovalStats approved={stats.approved} rejected={stats.rejected} />
      {props.showKpiTiles ? (
        <Card.Group itemsPerRow={3} stackable doubling style={{ marginBottom: "1.5em" }}>
          <KpiTile
            label="Total"
            value={stats.value}
            previousValue={stats.previousValue}
            deltaPercentage={stats.deltaPercentage}
            trend={stats.trend?.key ?? null}
            color="blue"
            comparisonHint={comparisonHint}
          />
          <KpiTile label="Approved" value={stats.approved} icon="check" color="green" />
          <KpiTile label="Rejected" value={stats.rejected} icon="times" color="red" />
        </Card.Group>
      ) : null}
    </>
  );
};

export default PermitRequestApprovalStatsContainer;
